import { getNestedProperty } from '@opallabs/lambda'
import {
  Assignment,
  AssignmentCollection,
  State,
  StateKeys,
} from '../../../../types'

type GetAssignments = (state: State) => AssignmentCollection | undefined

type GetAssignment = (state: State) => Assignment | undefined

type GetAssignmentFactory = (id: number) => GetAssignment

export type GetAssignmentsByStage = (
  state: State,
  props: { id: string }
) => Assignment[] | undefined

export const getAssignments: GetAssignments = (state) =>
  getNestedProperty<AssignmentCollection>(
    state,
    StateKeys.jsonApiEntities,
    StateKeys.assignment
  )

export const getAssignment: GetAssignmentFactory =
  (id) =>
  (state: State): Assignment | undefined => {
    const assignmentCollection = getAssignments(state)
    if (assignmentCollection !== undefined) {
      return assignmentCollection[id]
    }
    return undefined
  }

export const getAssignmentsByStage: GetAssignmentsByStage = (state, props) => {
  const assignmentCollection = getAssignments(state)
  if (assignmentCollection !== undefined) {
    return Object.values(assignmentCollection).filter(
      (assignment) =>
        getNestedProperty<string>(
          assignment,
          'relationships',
          'stage',
          'id'
        ) === props.id
    )
  }
  return undefined
}
